import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PAGE_EVENTS } from 'client/constants/page-events';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';

import './reveal-on-intersect.scss';

export function RevealOnIntersect({ children = null, threshold = 0.1, transform = 'translateY(50px)' }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isIntersected, setIsIntersected] = useState(false);
  const ref = useRef();
  const [isRefVisible] = useOnScreen(ref, {
    threshold,
  });

  useEffect(() => {
    function showLoaded() {
      setIsLoaded(true);
    }

    EventToolbox.on(PAGE_EVENTS.PAGE_LOAD, showLoaded);
    return () => {
      EventToolbox.off(PAGE_EVENTS.PAGE_LOAD, showLoaded);
    };
  }, []);

  if (isRefVisible && !isIntersected) {
    setIsIntersected(true);
  }

  if (!children) {
    return null;
  }

  return (
    <div
      ref={ref}
      className={classnames('reveal-container', {
        revealed: isIntersected && isLoaded,
      })}
      style={{
        opacity: '0',
        transform,
      }}
    >
      {children}
    </div>
  );
}

RevealOnIntersect.propTypes = {
  children: PropTypes.node,
  threshold: PropTypes.number,
  transform: PropTypes.string,
};
